// @flow

import * as React from "react";

import {
  Page,
  Avatar,
  Icon,
  Grid,
  Card,
  Text,
  Table,
  Alert,
  Progress,
  colors,
  Dropdown,
  Button,
  StampCard,
  StatsCard,
  ProgressCard,
  Badge,
  ContactCard,
} from "tabler-react";

import C3Chart from "react-c3js";

import SiteWrapper from "./SiteWrapper.react";

function Home() {
  return (
    <SiteWrapper>
      <Page.Content title="Dashboard">
        <Grid.Row cards={true}>
          <Grid.Col lg={6}>
            <ContactCard
              cardTitle="City of Toronto"
              mapPlaceholder="./map.jpg"
              rounded
              alt="Generic placeholder image"
              name={"Current Issue"}
              address={{
                line1: "COVID 19",
                line2: "School Strikes",
              }}
              details={[
                { title: "Status", content: "Lockdown" },
                
              ]}
            />
          </Grid.Col>

          <Grid.Col md={6}>
            <Grid.Row>
            <Grid.Col sm={6}>
                <ProgressCard
                  header="Total Tests Adminstered Today"
                  content="1200"
                  progressColor="green"
                  progressWidth={80}
                />
              </Grid.Col>
              <Grid.Col sm={6}>
                <ProgressCard
                  header="Daily Testing Capability Remaining"
                  content="300"
                  progressColor="red"
                  progressWidth={20}
                />
              </Grid.Col>

              <Grid.Col sm={6}>
                <ProgressCard
                  header="Users online"
                  content="76"
                  progressColor="yellow"
                  progressWidth={34}
                />
              </Grid.Col>
            </Grid.Row>
          </Grid.Col>
        </Grid.Row>
        <Grid.Row cards deck></Grid.Row>
        <Grid.Row>
          <Grid.Col md={6} lg={12}>
            <Grid.Row>
              <Grid.Col sm={6} lg={3}>
                <StatsCard
                  layout={2}
                  movement={-3}
                  total="423"
                  label="Users online"
                  chart={
                    <C3Chart
                      style={{ height: "100%" }}
                      padding={{
                        bottom: -10,
                        left: -1,
                        right: -1,
                      }}
                      data={{
                        names: {
                          data1: "Users online",
                        },
                        columns: [["data1", 30, 40, 10, 40, 12, 22, 40]],
                        type: "area",
                      }}
                      legend={{
                        show: false,
                      }}
                      transition={{
                        duration: 0,
                      }}
                      point={{
                        show: false,
                      }}
                      tooltip={{
                        format: {
                          title: function (x) {
                            return "";
                          },
                        },
                      }}
                      axis={{
                        y: {
                          padding: {
                            bottom: 0,
                          },
                          show: false,
                          tick: {
                            outer: false,
                          },
                        },
                        x: {
                          padding: {
                            left: 0,
                            right: 0,
                          },
                          show: false,
                        },
                      }}
                      color={{
                        pattern: ["#5eba00"],
                      }}
                    />
                  }
                />
              </Grid.Col>

            </Grid.Row>
          </Grid.Col>
          
        </Grid.Row>
      </Page.Content>
    </SiteWrapper>
  );
}

export default Home;
